import { AtSign, CalendarDays, Check, Clock, FileText, Home, MessagesSquare, UserPlus } from "lucide-react";

export const NOTIFICATION_TYPE_ICONS = {
  stage_change: Home,
  document: FileText,
  overdue: Clock,
  due_reminder: Clock,
  invite: UserPlus,
  task_done: Check,
  mention: AtSign,
  message: MessagesSquare,
  inspection: CalendarDays,
} as const;

export const NOTIFICATION_RANGE_OPTIONS = [
  { value: "7", label: "Last 7 days" },
  { value: "30", label: "Last 30 days" },
  { value: "90", label: "Last 90 days" },
  { value: "all", label: "All time" },
];

export const NOTIFICATION_FILTERS = [
  { key: "", label: "All" },
  { key: "deal", label: "Deals" },
  { key: "task", label: "Tasks" },
];

// `orgOnly` tabs are hidden from externals rather than rendered as an empty
// state. A client has no organization, so "Brokerage profile" and "Status
// templates" could only ever show them "No organization" — a tab whose sole
// content is an explanation of why it is empty.
export const SETTINGS_TABS = [
  { key: "profile", label: "Your profile" },
  { key: "reminders", label: "Reminders", orgOnly: true },
  { key: "calendar", label: "Google Calendar", orgOnly: true },
  { key: "brokerage", label: "Brokerage profile", orgOnly: true },
  { key: "status-templates", label: "Status templates", orgOnly: true },
  { key: "security", label: "Security" },
];
